import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import petTypesReducer from './slices/petTypesSlice';
import petBreedsReducer from './slices/petBreedsSlice';
import countriesReducer from './slices/countriesSlice';
import statesReducer from './slices/statesSlice';
import citiesReducer from './slices/citiesSlice';
import featuresReducer from './slices/featuresSlice';
import petsReducer from './slices/petsSlice';
import usersReducer from './slices/usersSlice';
import dashboardReducer from './slices/dashboardSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import cmsReducer from './slices/cmsSlice';
import helpSupportReducer from './slices/helpSupportSlice';
import doctorsReducer from './slices/doctorsSlice';
import appointmentsReducer from './slices/appointmentsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    petTypes: petTypesReducer,
    petBreeds: petBreedsReducer,
    countries: countriesReducer,
    states: statesReducer,
    cities: citiesReducer,
    features: featuresReducer,
    pets: petsReducer,
    users: usersReducer,
    dashboard: dashboardReducer,
    subscription: subscriptionReducer,
    cms: cmsReducer,
    helpSupport: helpSupportReducer,
    doctors: doctorsReducer,
    appointments: appointmentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
